export default [
  {
    id: 1,
    rowStart: 1,
    rowEnd: 2,
    colStart: 1,
    colEnd: 4,
    color: '#F46036',
  },
  {
    id: 2,
    rowStart: 1,
    rowEnd: 3,
    colStart: 4,
    colEnd: 5,
    color: '#2E294E',
  },
  {
    id: 3,
    rowStart: 1,
    rowEnd: 4,
    colStart: 5,
    colEnd: 6,
    color: '#1B998B',
  },
  {
    id: 4,
    rowStart: 1,
    rowEnd: 3,
    colStart: 6,
    colEnd: 7,
    color: '#C5D86D',
  },
  {
    id: 5,
    rowStart: 2,
    rowEnd: 4,
    colStart: 1,
    colEnd: 2,
    color: '#BE6E46',
  },
  {
    id: 6,
    rowStart: 2,
    rowEnd: 3,
    colStart: 2,
    colEnd: 4,
    color: '#87F1FF',
  },
  {
    id: 7,
    rowStart: 3,
    rowEnd: 4,
    colStart: 3,
    colEnd: 5,
    color: '#C70039',
    goal: true,
  },
  {
    id: 8,
    rowStart: 4,
    rowEnd: 5,
    colStart: 1,
    colEnd: 3,
    color: '#7286A0',
  },
  {
    id: 9,
    rowStart: 4,
    rowEnd: 6,
    colStart: 3,
    colEnd: 4,
    color: '#59594A',
  },
  {
    id: 10,
    rowStart: 5,
    rowEnd: 7,
    colStart: 2,
    colEnd: 3,
    color: '#FFF05A',
  },
  {
    id: 11,
    rowStart: 6,
    rowEnd: 7,
    colStart: 3,
    colEnd: 5,
    color: '#191919',
  },
  {
    id: 12,
    rowStart: 5,
    rowEnd: 6,
    colStart: 5,
    colEnd: 7,
    color: '#FFAA5A',
  },
  {
    id: 13,
    rowStart: 6,
    rowEnd: 7,
    colStart: 5,
    colEnd: 7,
    color: '#FF785A',
  },
];
